/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepButton from "@material-ui/core/StepButton";
import StepContent from "@material-ui/core/StepContent";
import {
  Paper,
  Typography,
  Divider,
  TextField,
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
  Grid,
} from "@material-ui/core";

import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Clear from "@material-ui/icons/Clear";
import Add from "@material-ui/icons/Add";

import { v4 as uuidv4 } from 'uuid';

import FDropDown from "../../fluid/Elements/Inputs/FDropDown";

import Actions from "../../fluid/Actions/ActionFactory";
import AddWorldViewServer from "../WVServer/AddWorldViewServer";

import { allowedByOpop } from '../Security/SecureCheck';
import ErrorMessageAlert from "../../traditional/Utilities/ErrorMessageAlert";

const clone = require("rfdc")();

const styles = (theme) => ({
  text_field: {
    width: "100%",
    marginTop: "10px",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#f50157",
    },
  },
});

function getSteps() {
  return ["Select World View Server", "World View Fields"];
}

class AddWorldView extends Component {
  state = {
    activeStep: 0,
    steps: getSteps(),
    wv_server_list: [],
    wv_server: "",
    fields: [],
    data_types: [],
    submitting: false,
    add_wv_server: false,
    content_height: null,
    error: false,
    error_message: "",
    submit_error : null
  };

  headingPanel = React.createRef();

  componentWillMount() {
    Actions("http_request", {
      url: "/sainapse/data_types",
      method: "get",
      data: {},
    })
      .then((res) => {
        let data_types = res.data.result.map((result) => {
          return {
            value: result.type,
            label: result.annotation,
          };
        });
        this.setState({
          ...this.state,
          data_types: data_types,
          ic_name: this.props.ic_name,
        });
      })
      .catch((err) => {
        if (err.response) {
          this.handleError(err, "Error while fetching data types.");
        }
      });

    // this.setState({...this.state, ic_name : this.props.ic_name})
    // console.log('Add WV Height prop : ', this.props.maxHeight)
  }

  componentDidMount() {
    const content_height =
      this.props.maxHeight - this.headingPanel.current.clientHeight;
    this.setState({ ...this.state, content_height: content_height });
  }

  handleError = (err, genericMsg) => {
    let errorMessage;

    if (err.response) {
      let response = err.response.data;

      if (err.response.status === 404) {
        errorMessage = response.message || "Resource not found.";
      } else {
        if (response) {
          if (Array.isArray(response.errors)) {
            response.errors.forEach((errObj) => {
              errorMessage = errorMessage?.concat(errObj.message);
            });
          } else if (response.message) {
            errorMessage = response.message;
          } else {
            errorMessage = genericMsg;
          }
        }
      }
    }
    this.setState({
      error: true,
      error_message: errorMessage,
    });
  };

  closeError = () => {
    this.setState({ ...this.state, error: false, error_message: "" });
  };

  handleChange = (state_key, value) => {
    console.log("JSON Output: ", value);
    this.setState({ ...this.state, [state_key]: value });
  };

  handleStep = (step) => {
    this.setState({ ...this.state, activeStep: step });
  };

  handleNext = () => {
    this.setState({
      ...this.state,
      activeStep:
        this.state.activeStep === this.state.steps.length - 1
          ? this.state.activeStep
          : this.state.activeStep + 1,
    });
  };

  handleBack = () => {
    this.setState({
      ...this.state,
      activeStep:
        this.state.activeStep === 0
          ? this.state.activeStep
          : this.state.activeStep - 1,
    });
  };

  getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.renderWorldViewServer();

      case 1:
        return this.renderWorldViewFields();

      default:
        return null;
    }
  };

  openWorldViewDialog = () => {
    this.setState({ ...this.state, add_wv_server: true });
  };

  closeWorldViewDialog = () => {
    this.setState({ ...this.state, add_wv_server: false });
  };

  renderWorldViewServer = () => {
    return (
      <Fragment>
        <FDropDown
          instance={{
            label: "World View Server",
            helper_text: "Select the World View Server",
            props: {
              width: "50",
              variant: "standard",
            },
            value_store: ["wv_server"],
            eval_value: "",
            default_value: this.state.wv_server,
            async_values: true,
            api_config: {
              args: {
                url: "/sainapse/world_view_server",
                method: "get",
                data: {},
              },
              response_key: "result",
              val_key: "name",
              label_key: "",
            },
            values: [],
            render_condition: "",
            mandatory: true,
          }}
          handleChange={(state_key, value) =>
            this.handleChange(state_key, value)
          }
        />
        <Typography
          style={{ margin: 0, padding: 0, marginTop: "8px" }}
          variant="body2"
        >
          If the World View server you are looking for is not in the list,
          please register a new world view server below.
        </Typography>
        <Button
          style={{ marginTop: "8px", marginBottom: "8px", display: "block" }}
          color="primary"
          size="small"
          onClick={this.openWorldViewDialog}
        >
          Register New World View Server
        </Button>
        <Divider />
        {this.renderNavButtons("wv_server")}
      </Fragment>
    );
  };

  renderWorldViewFields = () => {
    return (
      <Fragment>
        <Typography variant="body22">
          <em>Add Fields to the World View to Proceed.</em>
        </Typography>
        <Divider
          style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}
        />
        <Grid
          container
          xs={12}
          spacing={0}
          direction="row"
          wrap="wrap"
          alignItems="center"
        >
          {this.generateFields()}
          <Grid item xs={3}>
            <IconButton
              style={{ display: "block" }}
              color="primary"
              size="small"
              onClick={this.addField}
            >
              <Add />
            </IconButton>
          </Grid>
        </Grid>
        {/* <FJsonSchemaGenerator
                    instance = {{
                        id : 'wv_field_list',
                        async_values : true,
                        default_value : this.state.fields,
                        api_config : {
                            args : {
                                url : '/sainapse/data_types',
                                method : 'get',
                                data : {}
                            },
                            response_key : "result",
                            val_key : "type",
                            label_key : "annotation"
                        },
                        values: [],
                        value_store : ["fields"]
                    }}
                    handleChange = {(state_key, value) => this.handleChange(state_key, value)}
                /> */}
      </Fragment>
    );
  };

  handleFieldChange = (key, value, id) => {
    let new_state = clone(this.state);
    let index = new_state.fields.findIndex((field) => field.id === id);
    let fields = new_state.fields;

    fields[index][key[0]] = value;

    this.setState({ ...new_state });
  };

  validateField = (id, key) => {
    if (key === "name") {
      let field_index = this.state.fields.findIndex((field) => field.id === id);
      let field_name = this.state.fields[field_index].name;

      if (field_name !== "") {
        let similar_name_index = this.state.fields.findIndex(
          (field) => field.name === field_name
        );
        if (similar_name_index !== -1 && similar_name_index !== field_index) {
          let fields = [...this.state.fields];
          fields[field_index].name_error = true;
          fields[field_index].name_error_message = "Field Name already exists";

          this.setState({ ...this.state, fields: fields });
        } else {
          let fields = [...this.state.fields];
          fields[field_index].name_error = false;
          fields[field_index].name_error_message = "";

          this.setState({ ...this.state, fields: fields });
        }
      }
    } else if (key === "data_type") {
      let field_index = this.state.fields.findIndex((field) => field.id === id);

      if (this.state.fields[field_index].data_type === "") {
        let fields = [...this.state.fields];
        fields[field_index].data_type_error = true;
        fields[field_index].data_type_error_message =
          "Field Type cannot be empty";

        this.setState({ ...this.state, fields: fields });
      } else {
        let fields = [...this.state.fields];
        fields[field_index].data_type_error = false;
        fields[field_index].data_type_error_message = "";

        this.setState({ ...this.state, fields: fields });
      }
    }
  };

  generateFields = () => {
    let fields = this.state.fields.map((field, index) => {
      return (
        <Grid item xs={3}>
          <Paper elevation={3} style={{ margin: "5px", padding: "5px" }}>
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <IconButton
                size="small"
                color="secondary"
                onClick={() => this.removeField(field.id)}
              >
                <Clear fontSize="small" />
              </IconButton>
            </div>
            <TextField
              style={{ width: "100%" }}
              key={field.id + "name"}
              label="Field Name"
              helperText={
                field.name_error === true
                  ? field.name_error_message
                  : "Name of the World View field"
              }
              error={field.name_error}
              value={field.name}
              autoFocus
              onChange={(event) =>
                this.handleFieldChange(["name"], event.target.value, field.id)
              }
              onBlur={() => this.validateField(field.id, "name")}
            />
            <FDropDown
              key={field.id + "data_type"}
              instance={{
                label: "Field Type",
                helper_text:
                  field.data_type_error === true
                    ? field.data_type_error_message
                    : "Choose the field type",
                props: {
                  width: "100",
                  variant: "standard",
                },
                value_store: ["data_type"],
                eval_value: "",
                value: field.data_type,
                async_values: false,
                api_config: {},
                values: this.state.data_types,
                render_condition: "",
                mandatory: true,
                error: field.data_type_error,
                onBlur: () => this.validateField(field.id, "data_type"),
              }}
              handleChange={(state_key, value) =>
                this.handleFieldChange(state_key, value, field.id)
              }
            />
          </Paper>
        </Grid>
      );
    });

    return fields;
  };

  addField = () => {
    let new_id = uuidv4()
    let new_field = {
      id: new_id,
      name: "",
      data_type: "",
      name_error: false,
      data_type_error: false,
      name_error_message: "",
      data_type_error_message: "",
    };

    let fields = [...this.state.fields];
    fields.push(new_field);

    this.setState({ ...this.state, fields: fields }, () =>
      console.log("WV State :", this.state)
    );
  };

  removeField = (id) => {
    let fields = [...this.state.fields];

    let index = fields.findIndex((field) => field.id === id);

    fields.splice(index, 1);

    this.setState({ ...this.state, fields: fields });
  };

  renderSubmitButton = () => {
    if (this.state.submitting === false) {
      return (
        <Button
          variant="contained"
          color="primary"
          disabled={this.state.fields.length === 0 ? true : false}
          onClick={this.validateAndSubmit}
        >
          Submit World View
        </Button>
      );
    } else {
      return <CircularProgress size={20} />;
    }
  };

  validateAndSubmit = () => {
    let new_state = clone(this.state);

    let fields = new_state.fields;

    let name_error = false;
    let type_error = false;

    let empty_name_index = fields.findIndex((field) => field.name === "");
    let empty_type_index = fields.findIndex((field) => field.data_type === "");

    if (empty_name_index !== -1) {
      console.log("Error in Name at :", empty_name_index);
      name_error = true;
      fields[empty_name_index].name_error = true;
      fields[empty_name_index].name_error_message =
        "Field Name cannot be empty";
    }

    if (empty_type_index !== -1) {
      console.log("Error in Type at :", empty_type_index);
      type_error = true;
      fields[empty_type_index].data_type_error = true;
      fields[empty_type_index].data_type_error_message =
        "Field Type cannot be empty";
    }

    if (name_error || type_error) {
      this.setState({ ...this.state, fields: fields });
    } else {
      this.submitWorldView();
    }
  };

  submitWorldView = () => {
    this.setState({ error_message: "" });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" + this.props.ic_name + "/world_view",
      method: "post",
      data: {
        fields: this.state.fields,
        server: this.state.wv_server,
      },
    })
      .then((res) => {
        let ic = {
          ic: res.data.result,
        };
        this.props.nextStep(ic);
      })
      .catch((err) => {
        // this.handleError(err, "Error while submitting world view.");
        this.setState({
          error: true,
          submit_error: err,
        });
      });
  };

  renderNavButtons = (state_key) => {
    if (this.state[state_key]) {
      return (
        <div
          style={{ display: "flex", flexDirection: "row", marginTop: "8px" }}
        >
          <ThemeProvider theme={blue_theme}>
            {/* <Tooltip title = 'Back'>
                            <IconButton onClick = {this.handleBack} color = 'primary'>
                                <ArrowUpward/>
                            </IconButton>
                        </Tooltip> */}
            <Tooltip title="Next">
              <IconButton onClick={this.handleNext} color="primary">
                <ArrowDownward />
              </IconButton>
            </Tooltip>
          </ThemeProvider>
        </div>
      );
    }
  };

  renderContent = () => {
    if (this.state.content_height !== null) {
      return (
        <div
          style={{
            width: "100%",
            height: this.state.content_height + "px",
            maxHeight: this.state.content_height + "px",
            overflow: "scroll",
          }}
        >
          <ThemeProvider theme={blue_theme}>
            <Stepper activeStep={this.state.activeStep} orientation="vertical">
              {this.state.steps.map((label, i) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                  <StepContent>{this.getStepContent(i)}</StepContent>
                </Step>
              ))}
            </Stepper>
            <AddWorldViewServer
              open={this.state.add_wv_server}
              handleClose={this.closeWorldViewDialog}
            />
          </ThemeProvider>
        </div>
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper
        square
        style={{
          width: "100%",
          height: this.props.maxHeight + "px",
          maxHeight: this.props.maxHeight + "px",
        }}
        elevation={4}
      >
        <div
          ref={this.headingPanel}
          style={{
            backgroundColor: "#F0F0F0",
            padding: "8px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Add World View</Typography>
            <Typography
              style={{ color: "#F50157", marginLeft: "10px" }}
              variant="caption"
            >
              {this.state.error_message}
            </Typography>
          </div>
          <ThemeProvider theme={blue_theme}>
            <Button
              variant="contained"
              color="primary"
              disabled={
                (this.state.fields.length === 0 || this.state.wv_server === ""
                  ? true
                  : false) && (!allowedByOpop({
                    operation : "/sainapse/information_channel/{ic_name}/world_view",
                    method : "POST",
                    operands : [
                      {
                        attrName: "ic_name",
                        value : this.props.ic_name
                  }]
                  }))
              }
              onClick={this.validateAndSubmit}
            >
              Submit World View
            </Button>
          </ThemeProvider>
        </div>
        {this.renderContent()}
        {this.state.error === true && (
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.submit_error}
          />
        )}
      </Paper>
    );
  }
}

export default withStyles(styles)(AddWorldView);
